'use client';

import React, { useEffect, useRef } from 'react';
import { Autoplay, Navigation, Pagination, Scrollbar } from 'swiper/modules';
import { Swiper, SwiperSlide } from 'swiper/react';
import { getImageUrl } from '@/utils/string';
import { imageTypes } from '@/constants/types';
import ImageComponentV2 from '../Image/ImageComponentV2';

// swiper slider
import 'swiper/css';
import 'swiper/css/navigation';
import 'swiper/css/pagination';

function CardSliderForThreeCard({ data = [] }) {
  const swiperRef = useRef(null);

  // prevent event propagation on pagination click
  useEffect(() => {
    if (swiperRef.current) {
      const swiperInstance = swiperRef.current;
      const paginationEl = swiperInstance.pagination.el;

      if (paginationEl) {
        paginationEl.addEventListener('click', (e) => {
          e.stopPropagation();
        });
      }

      return () => {
        if (paginationEl) {
          paginationEl.removeEventListener('click', (e) => {
            e.stopPropagation();
          });
        }
      };
    }
  }, []);

  return (
    <div
      className="min-h-[159px] lg:min-h-[317px] relative"
      onMouseEnter={() => swiperRef.current?.autoplay.start()}
      onMouseLeave={() => swiperRef.current?.autoplay.stop()}
    >
      <Swiper
        onSwiper={(swiper) => {
          swiperRef.current = swiper;
        }}
        modules={[Autoplay, Navigation, Pagination, Scrollbar]}
        // spaceBetween={10}
        slidesPerView="auto"
        speed={1000}
        pagination={{ clickable: true }}
        className="swiper_slider card-slider"
      >
        {data?.images?.wide?.map((item, index) => (
          <SwiperSlide
            key={item?.id || index}
            className="!flex !justify-center"
          >
            <div className="relative w-full max-w-[200px] lg:max-w-[380px] 2xl:max-w-[400px] h-[160px] lg:h-[317px] overflow-hidden">
              {item ? (
                <ImageComponentV2
                  src={item?.image_2x ? getImageUrl(item?.image_2x) : null}
                  alt={data?.name?.en}
                  className="w-full h-full object-contain object-center"
                  type={imageTypes.wide}
                  width={400}
                  height={317}
                  loading="lazy"
                />
              ) : (
                <ImageComponentV2
                  src={null}
                  alt={data?.name?.en}
                  className="w-full h-full object-contain object-center"
                  type={imageTypes.wide}
                  width={400}
                  height={317}
                  loading="lazy"
                />
              )}
            </div>
          </SwiperSlide>
        ))}
      </Swiper>

      {!data?.images?.wide ? (
        <SwiperSlide className="!flex !justify-center">
          <ImageComponentV2
            src={null}
            alt={data?.name?.en}
            className="w-full h-full object-contain object-center"
            width={400}
            height={317}
            loading="lazy"
          />
        </SwiperSlide>
      ) : null}
    </div>
  );
}

export default CardSliderForThreeCard;
